import styled from 'styled-components';

export const Container = styled.div`
  h1 {
    color: var(--orange);
    font-size: 40px;
    line-height: 3rem;
  }
`;

export const FlexRow = styled.div`
  display: flex;

  .right {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    width: 100%;
  }
`;

export const TableWrapper = styled.div`
  margin-top: 35px;
  .header {
    background-color: #ebf1f4;
    TableCell {
      font-weight: bold;
    }
  }
`;

export const Content = styled.div`
  width: 100%;
  border: 1px solid #e8e8e8;
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 25px;
  padding-bottom: 25px;
  margin-top: 20px;

  h2 {
    color: var(--purple);
    margin-bottom: 10px;
    margin-top: 7px;
  }
  div {
    margin-top: 5px;
    margin-bottom: 5px;
  }

  @media only screen and (max-width: 425px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`;
